module.exports = __webpack_public_path__ + "07_face.621db035.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/07_face.png
// module id = 0P9g
// module chunks = 0